<template>
    <v-app>    
        <v-main>
            <div class="portal-login" :style="cssVars">
                
                <p class="portal-login__sub">
                    
                </p>
                <div class="portal-login__bg">
                    <img src="@/assets/background.jpg" :alt="`${schoolName} campus`" class="portal-login__bg-img" />
                    <div class="portal-login__vignette" />
                </div>

                <header class="portal-login__topbar">
                    <div class="portal-login__brand">
                        
                    </div>
                </header>

                <main class="portal-login__stage">
                    <section class="portal-login__card" role="form" aria-labelledby="portal-login-heading">
                        <v-img
                            src="@/assets/logo.png"
                            max-width="140"
                            contain
                            class="d-flex mb-6"
                        ></v-img>
                        <h1 id="portal-login-heading" class="portal-login__heading mb-1">
                            {{ schoolName }}<span class="portal-login__heading-dot">.</span>
                        </h1>

                        <p class="portal-login__sub">
                            Through Perseverence Success
                        </p>
                        <slot name="cards"></slot>
                    </section>
                </main>

               
            </div>                   
        </v-main>
        
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Background',
    data: () => ({
        //    
    }),

    computed: {
        ...mapGetters({
            schoolName: 'app/getSchoolName',
        }),
        cssVars() {
            return {
                '--accent': this.accentColor,
            }
        },
    },

   
}
</script>

<style scoped>
    .container-background{
        background-image: url('../../assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }

     .portal-login__heading {
    margin: 0;
    font-family: 'Fraunces', Georgia, 'Times New Roman', serif;
    font-weight: 500;
    font-size: 34px;
    line-height: 1.1;
    color: var(--cream);
    }

    .portal-login__heading-dot {
    color: var(--oxide);
    }

    .portal-login {
    --ink: #1a2e1c;
    --cream: #f5f1e6;
    --oxide: #8b2e2e;
    --brass: #c9a15a;
    --accent: #3f6b3f;
    position: relative;
    min-height: 100vh;
    width: 100%;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    overflow: hidden;
    }

    .portal-login__bg {
    position: absolute;
    inset: 0;
    z-index: 0;
    }

    .portal-login__bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: saturate(0.92) contrast(1.02);
    }

    .portal-login__vignette {
    position: absolute;
    inset: 0;
    background:
        linear-gradient(180deg, rgba(15, 22, 16, 0.55) 0%, rgba(15, 22, 16, 0.35) 30%, rgba(15, 22, 16, 0.75) 100%),
        linear-gradient(90deg, rgba(15, 22, 16, 1) 0%, rgba(15, 22, 16, 0.65) 35%, rgba(15, 22, 16, 0.05) 100%);
    }

    .portal-login__topbar {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 28px 40px;
    }

    .portal-login__brand {
    display: flex;
    align-items: center;
    gap: 10px;
    }

    .portal-login__crest {
    width: 60px;
    height: 60px;
    object-fit: contain;
    }

    .portal-login__brand-name {
    color: var(--cream);
    font-weight: 600;
    letter-spacing: 0.02em;
    font-size: 15px;
    }

    .portal-login__stage {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    min-height: calc(90vh - 40px);
    padding: 20px clamp(20px, 6vw, 96px);
    }

    .portal-login__card {
    width: 100%;
    max-width: 600px;
    padding: 40px 36px 32px;
    }

    .portal-login__eyebrow {
    margin: 0 0 10px;
    font-size: 11px;
    letter-spacing: 0.16em;
    color: var(--brass);
    font-weight: 600;
    text-transform: uppercase;
    }

    .portal-login__heading {
    margin: 0;
    font-family: 'Fraunces', Georgia, 'Times New Roman', serif;
    font-weight: 500;
    font-size: 34px;
    line-height: 1.1;
    color: var(--cream);
    }

    .portal-login__heading-dot {
    color: var(--oxide);
    }

    .portal-login__sub {
    margin: 0 0 26px;
    font-size: 13.5px;
    line-height: 1.5;
    color: rgba(245, 241, 230, 0.75);
    }

    .portal-login__form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    }

    .portal-login__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    }

    .portal-login__field-label {
    font-size: 11.5px;
    letter-spacing: 0.04em;
    color: rgba(245, 241, 230, 0.6);
    text-transform: uppercase;
    }
       
</style>